<template>
    <ValidationProvider :vid="vid" :name="$attrs.label" :rules="rules" v-slot="{errors}">
        <v-select
            v-bind="$attrs"
            v-on="$listeners"
            dense
            color="primary"
            :error-messages="errors"
        />
    </ValidationProvider>
</template>
<script>
export default {
    props: {
        rules: String,
        vid: String,
    },
    computed: {
    },
    methods: {
    }
}
</script>
<style scoped>

</style>